import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';

import { AlertService, AuthenticationService, CryptoService, StorageServiceProvider } from '../../_services/services';
// import { Md5 } from 'ts-md5';
import utils from './../../utils';
import { Title } from '@angular/platform-browser';
import { Global } from 'src/app/globals';
import * as Sentry from '@sentry/angular';
import { StorageKeys } from 'src/app/_constants';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared.module';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingService } from 'src/app/_services/loading.service';

@Component({
    selector: 'app-login',
    templateUrl: 'login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: true, // Required for Angular 18's new standalone components
    imports: [
        SharedModule,
        MaterialModule
    ]
})

export class LoginComponent implements OnInit {
    model: any = {};
    returnUrl: string;
    selectedDataset: string;
    @ViewChild('loginId') loginElement: ElementRef;
    @Input() isFromAppSettings: boolean;
    hide = true;
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        public globals: Global,
        private alertService: AlertService,
        private cryptoService: CryptoService,
        private storage: StorageServiceProvider,
        private blockUI: LoadingService) {
        // this.titleService.setTitle("Login");
        let dataSet = this.storage.get(StorageKeys.DataSet);;
        this.selectedDataset = dataSet ? dataSet.TenantName : '';
        // this.globals.signalR.On('ReturnedLoginResponse', this.loginResponse)
    }

    ngOnInit() {
        setTimeout(() => {
            this.loginElement.nativeElement.focus();
        }, 0);
        if (localStorage.getItem('dataSet')) {
            this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
            if (localStorage.getItem('agrisLicense')) {
                this.globals.isAuthenticated = true;
                sessionStorage.setItem('isAuthenticated', 'true');
                this.router.navigate([this.returnUrl]);
            }
            else {
                this.authenticationService.logout();
            }
        }
        else
            this.router.navigate(['/appsettings']);
    }

    login() {
        if (localStorage.getItem('agrisLicense')) {
            this.globals.isAuthenticated = true;
            sessionStorage.setItem('isAuthenticated', 'true');
            if (utils.getLocation()) {
                this.router.navigate([this.returnUrl]);
            }
            else {
                this.router.navigate(['/settings']);
            }
        }
        else {
            this.blockUI.start();
            this.authenticationService.authenticateLogin(this.model.loginid, this.model.password, this.loginResponse);
        }
        // this.globals.signalR.AuthenticateUser(this.model.loginid, encrptedPassword);
    }
    loginResponse = (response, resultString) => {
        this.blockUI.stop();
        //response.Code == 200
        if (response === true) {
            this.authenticationService.login(response.sessionToken);
            localStorage.setItem('loginUserId', this.model.loginid);
            Sentry.getCurrentScope().setTag("loggedInUser", this.model.loginid);
            this.authenticationService.getUserPermissions(this.model.loginid, (permissions) => {
                console.log(permissions);
                localStorage.setItem('UserPermission', this.cryptoService.encryptString(JSON.stringify(permissions)));
                this.blockUI.stop();
                this.router.navigate([this.returnUrl]);
            }, (error) => {
                console.log(error);
                Sentry.captureMessage("Handled Error: " + JSON.stringify(error));
                this.alertService.error(error.Message);
            });
        }
        // (response.Code == 500)
        else if (response === false) {
            this.blockUI.stop();
            let message: string = "";
            if (resultString) {
                message = utils.ParseResultFromLicenseCall(resultString);
                this.alertService.error(message);
            } else {
                if (response.error && response.error.Message)
                    this.alertService.error(response.error.Message);
            }
        }
        else if (response.error.Code === 401) {
            this.blockUI.stop();
            let message: string = "";
            message = "Sorry, the app is unable to connect to the agent. Please try again or contact your administrator."
            this.alertService.error(message);
        }
        else {
            this.blockUI.stop();
            let message: string = "";
            if (resultString) {
                message = utils.ParseResultFromLicenseCall(resultString);
                this.alertService.error(message);
            } else {
                console.log(response);
                Sentry.captureMessage("Handled Error" + JSON.stringify(response));
                this.alertService.error(JSON.stringify(response));
            }
        }
    };
    appSettings() {
        this.router.navigate([this.returnUrl]);
    };



}
